import { render } from "./introduction_new.vue?vue&type=template&id=413587d9&scoped=true"
import script from "./introduction_new.vue?vue&type=script&lang=js"
export * from "./introduction_new.vue?vue&type=script&lang=js"

import "./introduction_new.vue?vue&type=style&index=0&id=413587d9&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413587d9"]])

export default __exports__